import React from 'react';
import { HeartIcon } from 'lucide-react';
import { Stars } from './Stars';
import { shortReviews } from '../data/content';
export function ShortReviews() {
  return <section aria-labelledby="short-reviews" className="bg-ink px-5 pb-20" data-id="element-262" data-mp="2biz5xzhrli5r">
      <div className="mx-auto max-w-6xl" data-id="element-263" data-mp="1xlapd3uqcx6i">
        <h2 id="short-reviews" className="flex items-center justify-center gap-2 text-center text-xl font-black uppercase tracking-wide text-white sm:text-2xl" data-id="element-264" data-mp="21mmg5cpcboga">
          <HeartIcon className="h-6 w-6 fill-coral text-coral" aria-hidden="true" data-id="element-265" data-mp="1nto56i0eznrm" />
          Lo que dicen las familias
        </h2>
        <ul className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-266" data-mp="1dxuuz5a646d0">
          {shortReviews.map((r, i) => <li key={i} className="flex flex-col rounded-2xl border border-line bg-surface p-6" data-id="element-267" data-mp="1iweg53gxte4b" data-mpi={i}>
              <Stars data-id="element-268" data-mp="14x548fzrl665" />
              <blockquote className="mt-4 text-base font-semibold leading-relaxed text-cream" data-id="element-269" data-mp="14xy02lx6qb9i">«{r.quote}»</blockquote>
              <p className="mt-auto pt-5 text-sm font-bold text-muted" data-id="element-270" data-mp="19uoihfwgpiy3">
                — {r.name} <span className="text-line" data-id="element-271" data-mp="1npxnnp7ok0mv">|</span> {r.country}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}